// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"360":"sql-formatter","384":"jspdf","502":"vendor","526":"html2canvas"}[chunkId] + "." + {"360":"9c3c17ff681d73932cfa","384":"110fdcfae91ba1ad8bcd","502":"c724c5237db663503eff","526":"91076565dc189cd13f5c"}[chunkId] + ".js";
};